import React, { useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Empty, Alert } from 'antd';
import ShopifyIntegrationActions from '@Actions/integrations/shopifyIntegrationActions';
import './style.scss';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import ShopifyConnectionList from '../ShopifyConnectionList';

/**
 *
 */
function ShopifyHome({
  getShopifyConnections, user, getShopifyConnectionsLoading, shopifyConnections, history,
}) {
  const [isUserAllReadyConnected, setIsUserAllReadyConnected] = React.useState(false);

  useEffect(() => {
    getShopifyConnections(user?.tenant_info?.org_id);
  }, []);

  useEffect(() => {
    if (shopifyConnections?.length) {
      setIsUserAllReadyConnected(true);
    } else {
      setIsUserAllReadyConnected(false);
    }
  }, [shopifyConnections]);

  return (
    <div className="shopify-integration-wrapper">
      <div className="shopify-integration__heading">Shopify Integration </div>

      { !getShopifyConnectionsLoading ? (
        <React.Fragment>
          {isUserAllReadyConnected === true && (
            <React.Fragment>
              <div className="shopify-list-wrapper">
                {/* <Alert
                  message="Please select the organisation to be connected with procuzy account. Organisation selection is a one time process and cannot be changed once confirmed."
                  type="warning"
                  showIcon
                /> */}
              </div>
              <ShopifyConnectionList />
            </React.Fragment>
          )}
          {isUserAllReadyConnected === false
            && (
              <React.Fragment>
                <div className="no-shopify-found__wrapper">
                  <Empty
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                    description=""
                  />
                  <p className="no-shopify-found__heading">Your Procuzy account is not yet connected to shopify</p>
                  <div>
                    <H3Button
                      text="Connect Now"
                      buttonType={defaultButtonTypes.BLUE_ROUNDED}
                      onClick={() => {
                        history.push('/admin/integration/shopify/connect');
                      }}
                      customClass="shopify__location-submit"
                      isLoading={getShopifyConnectionsLoading}
                      disabled={getShopifyConnectionsLoading}
                    />
                  </div>
                </div>
              </React.Fragment>
            )}

        </React.Fragment>
      ) : (
        <div
          className="shopify-list-wrapper"
        >
          {

            [1, 2, 3].map((item) => (
              <div
                key={item}
                className="loading-shopify__card"
              >
                <div className="shopify-card-spacing">

                  <div className="shopify-card-header ">

                    <div className="loadingBlock loading-shopify-header__text" />
                    <div className="loadingBlock loading-shopify-header__image"> </div>
                  </div>

                  <div className="loadingBlock loading-shopify-card__link"> </div>
                  <div className="shopify-card-footer">
                    <div
                      className="flex "
                    >
                      <p className="loadingBlock loading-shopify-card__footer" />
                    </div>
                  </div>
                </div>
              </div>

            ))

          }

        </div>
      ) }
    </div>
  );
}

const mapStateToProps = ({ ShopifyIntegrationReducers, UserReducers }) => ({
  shopifyConnections: ShopifyIntegrationReducers.shopifyConnections,
  getShopifyConnectionsLoading: ShopifyIntegrationReducers.getShopifyConnectionsLoading,
  user: UserReducers.user,
});
const mapDispatchToProps = (dispatch) => ({
  getShopifyConnections: (orgId, callback) => dispatch(ShopifyIntegrationActions.getShopifyConnections(orgId, callback)),
  connectToShopify: (orgId, callback) => dispatch(ShopifyIntegrationActions.connectToShopify(orgId, callback)),

});
ShopifyHome.propTypes = {
  user: PropTypes.any,
  history: PropTypes.any,
  shopifyConnections: PropTypes.any,
  getShopifyConnections: PropTypes.func,
  getShopifyConnectionsLoading: PropTypes.bool,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(ShopifyHome));
